import { IFilter } from '../../types/advancedFilters';
import { DemolitionContainer } from '../../containers/advancedFilters/DemolitionContainer';
import { isAvailableRegion } from '../../../../JsonQuery';
import { MOSCOW_ID } from '../regions';

export const demolition: IFilter = {
  availability: isAvailableRegion([MOSCOW_ID]),
  component: DemolitionContainer,
};
